<template>
  <generic-container
    :title="$t('odoo integration')"
    icon="tools"
    :show_refresh="true"
    :show_plus="true"
    @refresh="init"
    @add="add"
  >
    <div class="ui two cards">
      <div class="card" v-for="(integration, iidx) in integrations" :key="iidx">
        <div class="content">
          <img
            class="right floated mini ui image"
            src="/images/icons/enterprise_1.png"
          />
          <div class="header">{{ integration.name }}</div>
          <div class="meta">{{ integration.felgt_emitter.name }}</div>
          <!-- <div class="description">
            <pre>{{ integration }}</pre>
          </div> -->
        </div>
        <div class="extra content">
          <div class="ui two buttons">
            <div class="ui basic button" @click="edit(integration)">
              <i class="edit orange icon"></i> {{ $t("edit") }}
            </div>
            <div class="ui basic button" @click="remove(integration)">
              <i class="trash red icon"></i> {{ $t("delete") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ui grid">
      <div class="four wide column">
        <div
          class="ui vertical fluid pointing menu"
          ref="tabs_billing"
          v-if="integrations.length"
        >
          <a
            class="item"
            :data-tab="'b' + idx"
            v-for="(lyt, idx) in integrations"
            :key="idx"
          >
            <i class="settings icon"></i>
            {{ lyt.setup.integration_name || $t("unnamed") }}
          </a>
        </div>
      </div>
      <div class="twelve wide stretched column">
        <div
          class="ui tab segment"
          :data-tab="'b' + idx"
          v-for="(intg, idx) in integrations"
          :key="idx"
          style="margin-top: 0"
        >
          <odoo-integration v-model="integrations[idx]" />
        </div>
      </div>
    </div> -->
    <odoo-integration-modal ref="odoo_integration_modal" @saved="init" />
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer.vue";
import OdooIntegrationModal from "./odoo_integration_modal/Index";
// import OdooIntegration from "./odoo_integration/Index";
import {
  local_api,
  //   enterprise_setup,
  // init_ajax_data_datables,
  error_toast,
  // success_toast,
  // register_listener,
} from "@/utils";
// import { v4 } from "uuid";

export default {
  name: "OdooIntegrationComponent",
  components: {
    GenericContainer,
    OdooIntegrationModal,
    // OdooIntegration,
  },
  data() {
    return {
      integrations: [],
    };
  },
  methods: {
    init() {
      let vm = this;

      local_api(
        vm,
        "post",
        "/intercable_billing/odoo_integration/do-get-all",
        {},
      )
        .then((rintegrations) => {
          vm.integrations = rintegrations;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    empty() {
      let vm = this;
      vm.integration = [];
    },
    add() {
      let vm = this;
      // vm.integrations.push({
      //   uuid: "",
      //   setup: {
      //     integration_name: "",
      //     odoo_emitter_id: "",
      //     fel_emitter_id: "",
      //     default_email: "",
      //     default_address: "",
      //     default_zip_code: "",
      //     default_country: "",
      //     default_department: "",
      //     default_municipality: "",
      //   },
      // });
      vm.$refs.odoo_integration_modal.show_modal();
    },
    edit(integration) {
      let vm = this;
      vm.$refs.odoo_integration_modal.show_modal(integration);
    },
    remove(integration) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove odoo integration?"),
        function () {
          local_api(
            vm,
            "post",
            "/intercable_billing/odoo_integration/do-remove",
            {
              u: integration.uuid,
            },
          )
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  watch: {
    integrations() {
      let vm = this;
      setTimeout(() => {
        window.jQuery(vm.$refs.tabs_billing).find(".item").tab();
      }, 200);
    },
  },
};
</script>
